import React from "react";
import { Loading } from "components/loading";
import { useAdminContent, useFeatureFlags } from "context/admin-content";
import { PatientInterestProvider } from "context/patient-interest";
import { RiskProfileProvider } from "context/risk-profile";
import { RiskReportProvider } from "context/risk-report";
import { PatientResultsDisplay } from "./patient-results-display";
import { RiskhubResults } from "./riskhub-results";
import { Completed } from "./completed";

export default function PatientResultsPage() {
  const adminData = useAdminContent();
  const featureFlags = useFeatureFlags();
  const surveyType = localStorage.getItem("surveyType");
  const params = new URLSearchParams(window.location.search);
  const fromRescreen = params.get("from") === "rescreen";
  const exploreOptions = params.get("explore-options") === "true";

  if (!adminData || adminData.isLoading) {
    return <Loading />;
  }

  if (fromRescreen && adminData?.rescreen?.approval_enabled) {
    return <Completed />;
  }

  if (
    !fromRescreen &&
    !exploreOptions &&
    featureFlags?.disablePatientApprovalForRemoteScreenings === false &&
    surveyType === "remote"
  ) {
    return <Completed />;
  }

  // Use the new RiskHub experience if the feature flag is enabled
  const ResultsComponent = featureFlags?.enableRiskhubExperience
    ? RiskhubResults
    : PatientResultsDisplay;

  return (
    <PatientInterestProvider>
      <RiskProfileProvider>
        <RiskReportProvider>
          <ResultsComponent />
        </RiskReportProvider>
      </RiskProfileProvider>
    </PatientInterestProvider>
  );
}
